'use client';

import React from 'react';
import { cn } from '@/lib/utils';
import { motion, useAnimation } from 'framer-motion';

interface IconProps {
	isHovered?: boolean;
}

const dashVariants = {
	normal: {
		x: 0,
		transition: {
			duration: 0.6,
			type: 'spring',
			stiffness: 200,
			damping: 25,
		},
	},
	animate: {
		x: [1, -1, 1, -1, 1, 0],
		transition: {
			duration: 1.1,
			repeat: Infinity,
			ease: 'linear',
		},
	},
};

const arrowVariants = {
	normal: {
		x: 0,
		scale: 1,
		transition: {
			duration: 0.6,
			type: 'spring',
			stiffness: 200,
			damping: 25,
		},
	},
	animate: {
		x: [2, -2, 2, -2, 2, 0],
		scale: 1.3,
		transition: {
			duration: 1.1,
			repeat: Infinity,
			ease: 'linear',
			scale: {
				duration: 0.2,
				type: 'spring',
				stiffness: 200,
				damping: 25,
			},
		},
	},
};

export function LeftArrowIcon({ isHovered }: IconProps) {
	const controls = useAnimation();

	React.useEffect(() => {
		if (isHovered) {
			controls.start('animate');
		} else {
			controls.start('normal');
		}
	}, [isHovered, controls]);

	return (
		<div className='select-none p-1 flex items-center justify-center'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='28'
				height='28'
				viewBox='0 0 24 24'
				fill='none'
				stroke='currentColor'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
				className={cn(
					'transition-colors text-pink-500',
					isHovered && 'text-white'
				)}
			>
				<motion.path
					d='M19 15V9'
					variants={dashVariants}
					initial='normal'
					animate={controls}
				/>
				<motion.path
					d='M15 15h-3v4l-7-7 7-7v4h3v6z'
					variants={arrowVariants}
					initial='normal'
					animate={controls}
				/>
			</svg>
		</div>
	);
}
